/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FRDIds } from "./FRDIds";
import { FRDIdsFromJSON, FRDIdsFromJSONTyped, FRDIdsToJSON, FRDIdsToJSONTyped } from "./FRDIds";

/**
 *
 * @export
 * @interface ApiFrdIdsList200Response
 */
export interface ApiFrdIdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiFrdIdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiFrdIdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiFrdIdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<FRDIds>}
   * @memberof ApiFrdIdsList200Response
   */
  results: Array<FRDIds>;
}

/**
 * Check if a given object implements the ApiFrdIdsList200Response interface.
 */
export function instanceOfApiFrdIdsList200Response(
  value: object
): value is ApiFrdIdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiFrdIdsList200ResponseFromJSON(json: any): ApiFrdIdsList200Response {
  return ApiFrdIdsList200ResponseFromJSONTyped(json, false);
}

export function ApiFrdIdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiFrdIdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(FRDIdsFromJSON),
  };
}

export function ApiFrdIdsList200ResponseToJSON(json: any): ApiFrdIdsList200Response {
  return ApiFrdIdsList200ResponseToJSONTyped(json, false);
}

export function ApiFrdIdsList200ResponseToJSONTyped(
  value?: ApiFrdIdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(FRDIdsToJSON),
  };
}
